import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthApiService extends BaseApiService {
  createUser(username: string): Observable<Object> {
    const query = { username };
    return this.http.post(`${this.baseUrl}/auth/create-user`, query);
  }

  register(username: string, password: string): Observable<Object> {
    const query = {
      username,
      password,
    };
    return this.http.post(`${this.baseUrl}/auth/register`, query);
  }

  login(username: string, password: string, deviceId: string): Observable<any> {
    const query = {
      username,
      password,
      deviceId,
    };
    return this.http.post(this.baseUrl + '/auth/login', query);
  }

  logout(deviceId: string): Observable<any> {
    const query = {
      deviceId,
    };
    return this.http.post(this.baseUrl + '/auth/logout', query);
  }

  otp(username: string, code: string, tfaToken: string, trust: boolean): Observable<any> {
    const query = {
      username,
      code,
      tfaToken,
      trust,
    };
    return this.http.post(this.baseUrl + '/auth/otp', query);
  }

  resendOtp(username: string, tfaToken: string): Observable<any> {
    const query = {
      username,
      tfaToken,
    };
    return this.http.post(this.baseUrl + '/auth/otp/send', query);
  }

  requestCode(email: string): Observable<Object> {
    const query = {
      email: email
    };
    return this.http.post(this.baseUrl + '/auth/reset-code/send', query);
  }

  validateCode(email: string, code: string): Observable<Object> {
    const query = {
      email: email,
      resetCode: code.toString()
    };

    return this.http.post(this.baseUrl + '/auth/reset-code/validate', query);
  }

  changePassword(email: string, code: string, password: string): Observable<Object> {
    const query = {
      email: email,
      resetCode: code.toString(),
      password: password
    };
    return this.http.post(this.baseUrl + '/auth/reset-code/change-password', query);
  }

  refreshToken(refreshToken: any): Observable<any> {
    const query = {
      refreshToken: refreshToken
    };
    return this.http.post(this.baseUrl + '/auth/refresh-token', query);
  }

  securityReport(code: any, query: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/auth/security-report/${code}`, { params: query });
  }

  // region # MFA
  qrCode(): Observable<any> {
    return this.http.post(this.baseUrl + '/auth/mfa/qrcode', {});
  }

  mfaRegister(code: string): Observable<any> {
    return this.http.post(this.baseUrl + '/auth/mfa/register', { code });
  }

  mfa(username: string, code: string, tfaToken: string, trust: boolean): Observable<any> {
    const query = {
      username,
      code,
      tfaToken,
      trust,
    };
    return this.http.post(this.baseUrl + '/auth/mfa', query);
  }
  // endregion
}
